import Vapi from 'vuex-rest-api/dist/index'
import http from 'src/http/index'
import { beforeRequestReset, createSuccess, deleteSuccess, updateSuccess } from 'components/utils/storeUtils'

const initialState = () => ({
  templates: null,
  template: {},
  template_components: null,
  template_component: {},
  components: null,
  component: {},
  component_elements: null,
  component_element: {},
  elements: null,
  element: {},
  rapports: null,
  rapport: {},
  tocItems: [],
  report_remarks: null,
  report_remark: {}
})

const templateDepKeys = [
  'template_components', 'template_component', 'component', 'element'
]

const componentDepKeys = [
  'component_elements', 'component_element', 'element'
]

const rapportage = new Vapi({
  axios: http.axios,
  baseURL: process.env.API_URL + '/rapportage',
  state: initialState()
})
  .get({
    action: 'GET_TEMPLATES',
    property: 'templates',
    queryParams: true,
    path: '/template'
  })
  .get({
    action: 'GET_TEMPLATE',
    property: 'template',
    queryParams: true,
    path: ({ id }) => `/template/${id}`,
    onSuccess: (state, payload) => {
      if (payload.data.template_componenten) {
        payload.data.template_componenten = payload.data.template_componenten.sort((val1, val2) => {
          return val1.index - val2.index
        })

        state.template = payload.data
      }
    },
    beforeRequest: beforeRequestReset('template', templateDepKeys, initialState())
  })
  .post({
    action: 'CREATE_TEMPLATE',
    property: 'template',
    path: '/template',
    queryParams: true,
    onSuccess: createSuccess('template', 'templates')
  })
  .post({
    action: 'UPDATE_TEMPLATE',
    property: 'template',
    queryParams: true,
    path: ({ id }) => `/template/${id}`,
    onSuccess: updateSuccess('template', 'templates')
  })
  .delete({
    action: 'DELETE_TEMPLATE',
    property: 'template',
    queryParams: true,
    path: ({ id }) => `/template/${id}`,
    onSuccess: deleteSuccess('template')
  })
  .get({
    action: 'GET_TEMPLATE_COMPONENTS',
    property: 'template_components',
    queryParams: true,
    path: '/template_component'
  })
  .get({
    action: 'GET_TEMPLATE_COMPONENT',
    property: 'template_component',
    queryParams: true,
    path: ({ id }) => `/template_component/${id}`
  })
  .post({
    action: 'CREATE_TEMPLATE_COMPONENT',
    property: 'template_component',
    path: '/template_component',
    queryParams: true,
    onSuccess: createSuccess('template_component', 'template_components')
  })
  .post({
    action: 'UPDATE_TEMPLATE_COMPONENT',
    property: 'template_component',
    queryParams: true,
    path: ({ id }) => `/template_component/${id}`,
    onSuccess: updateSuccess('template_component', 'template_components')
  })
  .delete({
    action: 'DELETE_TEMPLATE_COMPONENT',
    property: 'template_component',
    queryParams: true,
    path: ({ id }) => `/template_component/${id}`,
    onSuccess: deleteSuccess('template_component', 'template_components')
  })
  .get({
    action: 'GET_COMPONENTS',
    property: 'components',
    queryParams: true,
    path: '/component',
    beforeRequest: beforeRequestReset('component', componentDepKeys, initialState())
  })
  .get({
    action: 'GET_COMPONENT',
    property: 'component',
    queryParams: true,
    path: ({ id }) => `/component/${id}`,
    onSuccess: (state, payload) => {
      if (payload.data.component_elementen) {
        payload.data.component_elementen = payload.data.component_elementen.sort((val1, val2) => {
          return val1.index - val2.index
        })
      }
      state.component = payload.data
    }
  })
  .post({
    action: 'CREATE_COMPONENT',
    property: 'component',
    path: '/component',
    queryParams: true,
    onSuccess: createSuccess('component', 'components')
  })
  .post({
    action: 'UPDATE_COMPONENT',
    property: 'component',
    queryParams: true,
    path: ({ id }) => `/component/${id}`,
    onSuccess: updateSuccess('component', 'components')
  })
  .delete({
    action: 'DELETE_COMPONENT',
    property: 'component',
    queryParams: true,
    path: ({ id }) => `/component/${id}`,
    onSuccess: deleteSuccess('component')
  })
  .get({
    action: 'GET_COMPONENT_ELEMENTS_FROM_COMPONENT',
    property: 'component_elements',
    queryParams: true,
    path: ({ id }) => `component/${id}/component_elementen`,
    beforeRequest: beforeRequestReset('component_element', ['component_element', 'element'], initialState())
  })
  .get({
    action: 'GET_COMPONENT_ELEMENTS',
    property: 'component_elements',
    queryParams: true,
    path: '/component_element'
  })
  .get({
    action: 'GET_COMPONENT_ELEMENT',
    property: 'component_element',
    queryParams: true,
    path: ({ id }) => `/component_element/${id}`
  })
  .post({
    action: 'CREATE_COMPONENT_ELEMENT',
    property: 'component_element',
    path: '/component_element',
    queryParams: true,
    onSuccess: createSuccess('component_element', 'component_elements')
  })
  .post({
    action: 'UPDATE_COMPONENT_ELEMENT',
    property: 'component_element',
    queryParams: true,
    path: ({ id }) => `/component_element/${id}`,
    onSuccess: updateSuccess('component_element', 'component_elements')
  })
  .delete({
    action: 'DELETE_COMPONENT_ELEMENT',
    property: 'component_element',
    queryParams: true,
    path: ({ id }) => `/component_element/${id}`,
    onSuccess: deleteSuccess('component_element')
  })
  .get({
    action: 'GET_ELEMENTS',
    property: 'elements',
    queryParams: true,
    path: '/element'
  })
  .get({
    action: 'GET_ELEMENT',
    property: 'element',
    queryParams: true,
    path: ({ id }) => `/element/${id}`
  })
  .post({
    action: 'CREATE_ELEMENT',
    property: 'element',
    path: '/element',
    queryParams: true,
    onSuccess: createSuccess('element', 'elements')
  })
  .post({
    action: 'UPDATE_ELEMENT',
    property: 'element',
    queryParams: true,
    path: ({ id }) => `/element/${id}`,
    onSuccess: updateSuccess('element', 'elements')
  })
  .delete({
    action: 'DELETE_ELEMENT',
    property: 'element',
    queryParams: true,
    path: ({ id }) => `/element/${id}`,
    onSuccess: deleteSuccess('element')
  })
  .get({
    action: 'GET_RAPPORTS',
    property: 'rapports',
    queryParams: true,
    path: '/rapport'
  })
  .get({
    action: 'GET_RAPPORT',
    property: 'rapport',
    queryParams: true,
    path: ({ id }) => `/rapport/${id}`
  })
  .post({
    action: 'CREATE_RAPPORT',
    property: 'rapport',
    path: '/rapport',
    queryParams: true,
    onSuccess: createSuccess('rapport', 'rapports')
  })
  .post({
    action: 'UPDATE_RAPPORT',
    property: 'rapport',
    queryParams: true,
    path: ({ id }) => `/rapport/${id}`,
    onSuccess: updateSuccess('rapport', 'rapporten')
  })
  .delete({
    action: 'DELETE_RAPPORT',
    property: 'rapport',
    queryParams: true,
    path: ({ id }) => `/rapport/${id}`,
    onSuccess: deleteSuccess('rapport')
  })
  .get({
    action: 'GET_REPORT_REMARKS_FROM_ONDERZOEK',
    property: 'report_remarks',
    queryParams: true,
    path: ({ id }) => `onderzoek/${id}/report_remarks`,
    requestConfig: {
      baseURL: process.env.API_URL + '/inventarisatie'
    }
  })
  .get({
    action: 'GET_REPORT_REMARK',
    property: 'report_remark',
    queryParams: true,
    path: ({ id }) => `/report_remark/${id}`
  })
  .post({
    action: 'CREATE_REPORT_REMARK',
    property: 'report_remark',
    path: '/report_remark',
    onSuccess: createSuccess('report_remark', 'report_remarks')
  })
  .post({
    action: 'UPDATE_REPORT_REMARK',
    property: 'report_remark',
    path: ({ id }) => `/report_remark/${id}`,
    onSuccess: updateSuccess('report_remark', 'report_remarks')
  })
  .delete({
    action: 'DELETE_REPORT_REMARK',
    property: 'report_remark',
    queryParams: true,
    path: ({ id }) => `/report_remark/${id}`,
    onSuccess: deleteSuccess('report_remark')
  })
  .getStore()

// Init TOC
rapportage.state.tocItems = []
rapportage.state.tables = {}

rapportage.mutations.ADD_TOC_ITEM = (state, item) => {
  state.tocItems.push(item)
}

rapportage.mutations.SET_TOC = (state, items) => {
  state.tocItems = items
}

rapportage.mutations.RESET_TOC = (state, item) => {
  state.tocItems = []
}

rapportage.mutations.SET_TABLES = (state, items) => {
  state.tables = items
}

rapportage.mutations.RESET_TABLES = (state, item) => {
  state.tables = {}
}

rapportage.mutations.RESET_RAPPORTAGE_STATE = (state) => {
  const initial = initialState()
  for (const key in initial) {
    if (Object.prototype.hasOwnProperty.call(initial, key)) {
      state[key] = initial[key]
    }
  }
}

export default rapportage
